import { Link } from 'react-router-dom';
import Button from '../../atoms/Button';
import { useNavigate } from 'react-router-dom';

const FormSubmissionButtons = ({
  cancelURL = '',
  submissionHandler,
  loadStatus,
}) => {
  const navigate = useNavigate();

  return (
    <div className=' my-4 text-right sm:flex sm:justify-end'>
      {/* CANCEL BUTTON */}
      <div className='text-md cursor-pointer p-4 text-center font-bold uppercase md:mx-6'>
        <Link
          onClick={
            cancelURL === '' ? () => navigate(-1) : () => navigate(cancelURL)
          }
          id='cancelButton'
        >
          Cancel
        </Link>
      </div>
      {/* SUBMIT BUTTON */}
      <Button
        callback={submissionHandler}
        loading={loadStatus}
        testid='form-submit-button'
      >
        Save
      </Button>
    </div>
  );
};

export default FormSubmissionButtons;
